import ContactForm from "./ContactForm";

export const Careers = () => {
  return <ContactForm />;
};

export default Careers;
